import type { FC } from "react";

import { Helmet } from "react-helmet";

import { AssetsService } from "app/services/AssetsService";

import {
    LogoIconWrapper,
    LogoPrimaryText,
    LogoSubText,
    LogoTextWrapper,
    SolutionLogoWrapper,
} from "./styledComponents";
import type { ISolutionLogoProps } from "./types";

const DEFAULT_SUBTITLE = "By Similarweb";

export const SolutionLogo: FC<ISolutionLogoProps> = ({
    isCollapsed,
    onClick,
    logoImagePath,
    titleText,
    subTitleText = DEFAULT_SUBTITLE,
}) => {
    return (
        <>
            <Helmet>
                <link
                    rel="shortcut icon"
                    href={AssetsService.assetUrl(logoImagePath)}
                />
            </Helmet>
            <SolutionLogoWrapper
                $isCollapsed={isCollapsed}
                onClick={onClick}
            >
                <LogoIconWrapper>
                    <img src={AssetsService.assetUrl(logoImagePath)} />
                </LogoIconWrapper>
                {!isCollapsed ? (
                    <LogoTextWrapper $isCollapsed={isCollapsed}>
                        <LogoPrimaryText>{titleText}</LogoPrimaryText>
                        <LogoSubText>{subTitleText}</LogoSubText>
                    </LogoTextWrapper>
                ) : null}
            </SolutionLogoWrapper>
        </>
    );
};
